<template>
  <DropDownInput
    :label="$t('calculator.profit-trend-form.select-crypto')"
    :dropdownTitle="$t('calculator.profit-trend-form.select-crypto.title')"
    :canFilter="true"
    @filter="handleFilter"
    @open="dropDownHandler"
  >
    <template #value>
      {{ selectedCrypto.name }}
    </template>
    <template #input-side>
      <img class="side-icon" :src="getPaybisIconsUrl(`/colored/crypto-icons/${selectedCrypto.code.toUpperCase()}.svg`)" width="32" height="32" :alt="selectedCrypto.name" />
    </template>
    <template #default="{hide}">
      <ExchangeLoading v-if="availableCryptoCurrencies.loading" />
      <div v-else>
        <CryptoCurrency
          v-for="item in filteredList"
          :key="item.code"
          :selected="selectedCrypto === item.code"
          :currency="item.code"
          :icon="item.code.toUpperCase()"
          :label="item.name"
          @click.native="selectHandler(item, hide)"
        />
      </div>
    </template>
  </DropDownInput>
</template>

<script setup lang="ts">
import DropDownInput from "@kano/components/ProfitCalculator/Form/DropDownInput.vue";
import { ProfitCalculatorCurrency } from "@kano/types/profit-calculator";
import { useMemoize } from "@vueuse/core";
import { useSimpleList } from "@kano/composables";
import { getPaybisIconsUrl } from "@/helpers/cdnHelper";
import CryptoCurrency from "@kano/components/ExchangeFormV2/CryptoCurrency.vue";
import SeoClient from "@kano/services/clients/seo-client";

import { computed, ref } from "vue";
import ExchangeLoading from "@kano/components/ExchangeFormV2/ExchangeLoading.vue";

const props = defineProps<{
  value: ProfitCalculatorCurrency,
}>();

const emit = defineEmits<{
  (event: 'input', value: ProfitCalculatorCurrency): void,
}>();

const filterString = ref<string>('');
const selectedCrypto = ref<ProfitCalculatorCurrency>(props.value);
const getAvailableCryptoCurrencies = useMemoize(() => SeoClient.getAvailableCryptoCurrencies());
const { state: availableCryptoCurrencies, fetch: fetchAvailableCryptoCurrencies } = useSimpleList({
  loading: true,
  list: () => getAvailableCryptoCurrencies(),
});


const filteredList = computed(() => availableCryptoCurrencies.items.filter((item) => {
  return item.name.toLowerCase().includes(filterString.value.toLowerCase()) ||
    item.code.toLowerCase().includes(filterString.value.toLowerCase());
}));

const selectHandler = (option, closePopupHandler) => {
  selectedCrypto.value = option;
  emit('input', option);
  closePopupHandler();
};

const handleFilter = (filter) => {
  filterString.value = filter;
}

const dropDownHandler = async () => {
  await fetchAvailableCryptoCurrencies();
}
</script>

<style scoped lang="scss">
.side-icon {
  border-radius: 50%;
}
</style>